import { Component, Input, HostBinding } from '@angular/core';

/**
 * MDB Icon Component
 *
 * Displays Font Awesome icons with MDB5 styling.
 *
 * Usage:
 * ```html
 * <mdb-icon icon="home"></mdb-icon>
 * <mdb-icon icon="user" style="fas"></mdb-icon>
 * <mdb-icon icon="heart" style="far" size="2x"></mdb-icon>
 * <mdb-icon icon="spinner" spin></mdb-icon>
 * ```
 */
@Component({
  selector: 'mdb-icon',
  template: '',
  standalone: false,
})
export class MdbIconComponent {
  @Input() icon = '';
  @Input() style: 'fas' | 'far' | 'fab' | 'fal' | 'fad' = 'fas';
  @Input() size: 'xs' | 'sm' | 'lg' | '2x' | '3x' | '4x' | '5x' | '6x' | '7x' | '8x' | '9x' | '10x' | '' = '';
  @Input() spin = false;
  @Input() pulse = false;
  @Input() fixedWidth = false;
  @Input() border = false;
  @Input() pull: 'left' | 'right' | '' = '';
  @Input() rotate: '90' | '180' | '270' | '' = '';
  @Input() flip: 'horizontal' | 'vertical' | 'both' | '' = '';

  @HostBinding('class')
  get iconClasses(): string {
    const classes: string[] = [this.style];

    if (this.icon) {
      classes.push(`fa-${this.icon}`);
    }

    if (this.size) {
      classes.push(`fa-${this.size}`);
    }

    if (this.spin) {
      classes.push('fa-spin');
    }

    if (this.pulse) {
      classes.push('fa-pulse');
    }

    if (this.fixedWidth) {
      classes.push('fa-fw');
    }

    if (this.border) {
      classes.push('fa-border');
    }

    if (this.pull) {
      classes.push(`fa-pull-${this.pull}`);
    }

    if (this.rotate) {
      classes.push(`fa-rotate-${this.rotate}`);
    }

    if (this.flip) {
      classes.push(`fa-flip-${this.flip}`);
    }

    return classes.join(' ');
  }
}
